import clsx from 'clsx'

import { HelpCard } from 'components/common/helpCard/HelpCard'
import { AnalyticsActionType } from 'types/analytics.type'
import { trackAnalytics } from 'utils/analytics'

import styles from './Questions.module.scss'
import QuestionMarkImage from '../../assets/images/helpCards/questionmarkbubble.gif'
import ToolsTricksImage from '../../assets/images/helpCards/tipstricks.gif'
import IconCircle from '../../assets/images/icons/circle.svg'

interface Props {
  title: string
}

export const Questions = ({ title }: Props) => {
  const handleButtonClick = (type: string) => {
    const kind =
      type === 'faq'
        ? 'pg_act_toolsandsupport_questions_faqs_learnmore'
        : 'pg_act_toolsandsupport_questions_tipsandtricks_getstarted'
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: {
        action: kind,
        params: [],
      },
    })
  }
  return (
    <div className={`${styles.container}`}>
      <div className="relative">
        <h2 className={`${styles.mainTitle} mb-[60px]`}>{title}</h2>
        <img src={IconCircle} alt="" className="-z-1 absolute top-[-20px] right-1/2 mr-[76px]" />
      </div>
      <div className="grid lg2:!grid-cols-2 grid-cols-1 gap-x-5 lg2:gap-y-0 gap-y-5">
        <HelpCard
          onButtonClick={() => handleButtonClick('faq')}
          className={clsx(
            'col-span-1 bg-[#0B77D7] rounded-tl-[26px] rounded-bl-[26px]  py-6 pl-6 pr-9',
            styles.questionCard,
          )}
          title="FAQs"
          image={QuestionMarkImage}
          alt="question-bubble"
          description="Learn more about how The Playground and our tech tools will optimize your ways of working."
          buttonText="Learn More"
          url={process.env.REACT_APP_FAQ_PAGE}
        />
        <HelpCard
          onButtonClick={() => handleButtonClick('tipsntricks')}
          className={clsx(
            'col-span-1 bg-[#193ABE] rounded-tr-[26px] rounded-br-[26px]  py-6 pr-6 pl-9',
            styles.questionCard,
          )}
          title="Tips & Tricks"
          image={ToolsTricksImage}
          alt="tipsntricks"
          description="Get step-by-step onboarding resources and user guides."
          buttonText="Get Started"
          url={process.env.REACT_APP_TIPS_AND_TRICKS_PAGE}
        />
      </div>
    </div>
  )
}
